<ng-container *ngTemplateOutlet="pagination"></ng-container>

<div class="user-table mt-6 mb-6">
  <div class="user-table-row header">
    <div class="user-table-cell" style="flex-basis: 2.75rem">
      <input type="checkbox" [ngModel]="isSelectedAll" (click)="selectAll()">
    </div>
    <div class="user-table-cell flex-1">
      <p translate>紀錄編號</p>
      <div class="inline-flex-column" (click)="filters.idOrder = !filters.idOrder;filters.dateOrder = null">
        <i class="material-icons-round sort-icon" [ngClass]="{'text-lightgrey': !filters.idOrder}">arrow_drop_up</i>
        <i class="material-icons-round sort-icon" [ngClass]="{'text-lightgrey': filters.idOrder}">arrow_drop_down</i>
      </div>
    </div>
    <div class="user-table-cell flex-1">
      <p translate>服務日期</p>
      <div class="inline-flex-column" (click)="filters.dateOrder = !filters.dateOrder;filters.idOrder = null">
        <i class="material-icons-round sort-icon" [ngClass]="{'text-lightgrey': !filters.dateOrder}">arrow_drop_up</i>
        <i class="material-icons-round sort-icon" [ngClass]="{'text-lightgrey': filters.dateOrder}">arrow_drop_down</i>
      </div>
    </div>
    <div class="user-table-cell flex-1">
      <p translate>服務類型</p>
    </div>
    <div class="user-table-cell flex-1">
      <p translate>交易類別</p>
    </div>
    <div class="user-table-cell flex-1">
      <p translate>受助者</p>
    </div>
    <div class="user-table-cell flex-1">
      <p translate>義工</p>
    </div>
    <div class="user-table-cell flex-1">
      <p translate>時分</p>
    </div>
    <div class="user-table-cell flex-1">
      <p translate>操作</p>
    </div>
  </div>

  <div class="user-table-row" *ngFor="let transaction of displayedTransactions">
    <div class="user-table-cell" style="flex-basis: 2.75rem">
      <input type="checkbox" [(ngModel)]="transaction.selected">
    </div>
    <div class="user-table-cell flex-1">
      <p>{{ transaction.request.id }}</p>
    </div>
    <div class="user-table-cell flex-1">
      <p>{{ transaction.request.checkOutTime | date: 'yyyy-MM-dd' }}</p>
    </div>
    <div class="user-table-cell flex-1">
      <p>{{ transaction.request.service.name }}</p>
    </div>
    <div class="user-table-cell flex-1">
      <p class="text-green" *ngIf="transaction.transferee.uuId === userId" translate>收入</p>
      <p class="text-red" *ngIf="transaction.transferer.uuId === userId" translate>支出</p>
    </div>
    <div class="user-table-cell flex-1">
      <p>{{ transaction.transferer.chineseName }}</p>
    </div>
    <div class="user-table-cell flex-1">
      <p>{{ transaction.transferee.chineseName }}</p>
    </div>
    <div class="user-table-cell flex-1">
      <p
        [ngClass]="{'text-green': transaction.transferee.uuId===userId, 'text-red' : transaction.transferer.uuId===userId}">
        {{ transaction.amount | number }}</p>
    </div>
    <div class="user-table-cell flex-1">
      <p class="click-text-lightblue" [routerLink]="['/main/activity/overview/request', transaction.request.uuId]"
        translate>檢視</p>
      <p class="click-text-lightblue ml-8" (click)="deleteRequest(transaction.request.uuId)" translate>移除</p>
    </div>
  </div>

  <div class="user-table-row" *ngIf="displayedTransactions.length == 0">
    <div class="user-table-cell">
      <p class="text-lightgrey ml-4" translate>沒有紀錄</p>
    </div>
  </div>
</div>

<ng-container *ngTemplateOutlet="pagination"></ng-container>

<ng-template #pagination>
  <div class="inline-flex-row align-items-center">
    <div class="inline-flex-row align-items-center flex-1">
      <p translate>已選擇</p>
      <p class="ml-2 mr-2 text-orange">{{ selectedTransactions.length }}</p>
      <p translate>條紀錄</p>
    </div>

    <p class="click-text-lightblue mr-8" translate>匯出選項</p>
    <p class="click-text-lightblue mr-8" [ngClass]="{disabled: selectedTransactions.length == 0}"
      (click)="deleteRequestList()" translate>移除選項</p>

    <div class="pagination mr-4">
      <select class="pagination" [(ngModel)]="filters.itemsPerPage" (change)="filters.page = 1">
        <option [ngValue]=5 translate>5 項 / 頁</option>
        <option [ngValue]=10 translate>10 項 / 頁</option>
        <option [ngValue]=20 translate>20 項 / 頁</option>
        <option [ngValue]=30 translate>30 項 / 頁</option>
        <option [ngValue]=50 translate>50 項 / 頁</option>
      </select>
    </div>

    <i class="material-icons-round page-icon" [ngClass]="{'disabled': filters.page <= 1}"
      (click)="filters.page = filters.page - 1">chevron_left</i>
    <input type="number" class="page-input" [(ngModel)]="filters.page">
    <p class="ml-3 mr-3 text-grey">/</p>
    <p class="page-number">{{ pages }}</p>
    <i class="material-icons-round page-icon" [ngClass]="{'disabled': filters.page >= pages}"
      (click)="filters.page = +filters.page +1">chevron_right</i>
  </div>
</ng-template>